module.exports = __webpack_public_path__ + "img/bg.81928ae9.png";